import { createAction, handleActions } from 'redux-actions';

const isUnderUserGroupsRoute = new RegExp('/user-groups/(.*)');

export const userGroupMembersFetchInitialized = createAction(
  '@platform/query/userGroupMembers/list/init',
);
export const userGroupMembersFetchSucceeded = createAction(
  '@platform/query/userGroupMembers/list/success',
  payload => payload,
);
export const userGroupMembersFetchFailed = createAction(
  '@platform/query/userGroupMembers/list/failed',
);
export const userGroupMemberDeleteSucceeded = createAction(
  '@platform/command/userGroupMembers/delete/success',
  payload => payload,
);

interface IUser {
  id: string
  type: 'ppms/user'
  attributes: {
    email: string
  }
}

export interface IMembersState {
  isLoading: boolean
  members: IUser[]
  total: number
  failed: boolean
}

const initialState: IMembersState = {
  isLoading: false,
  members: [],
  total: 0,
  failed: false,
};


export interface IRouterPayload {
  location: {
    pathname: string
  }
}

export interface IMembersPayload {
  data: IUser[]
  meta: {
    total: number
  }
}

const reducer = handleActions<IMembersState, IMembersPayload & IRouterPayload>({
  [userGroupMembersFetchInitialized.toString()]: state => ({
    ...state,
    failed: false,
    isLoading: true,
  }),
  [userGroupMembersFetchSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    members: payload.data,
    total: payload.meta.total,
  }),
  [userGroupMembersFetchFailed.toString()]: state => ({
    ...state,
    failed: true,
    isLoading: false,
  }),
  '@@router/LOCATION_CHANGE': (state, { payload }) => {
    if (!isUnderUserGroupsRoute.test(payload.location.pathname)) {
      return initialState;
    }

    return {
      ...state,
    };
  },
}, initialState);

export default reducer;
